export enum UserRole {
    SBU = "R-SBU-01",
    TrialActualAdmin = "R-SU-Trial-Act-02",
    TrialBudgetAdmin = "R-SU-Trial-Bud-03",
    BusinessActualAdmin = "R-SU-BD-Act-04",
    BusinessBudgetAdmin = "R-SU-BD-Bud-05",
    SBUTrialActualAdmin = "R-SU-upload-Act-6a",
    SBUBusinessActualAdmin = "R-SU-upload-Act-6b",
    SBUTrialBudgetAdmin = "R-SU-upload-BUD-7a",
    SBUBusinessBudgetAdmin = "R-SU-upload-BUD-7b",
    TrialActualPortalControlAdmin = "R-SU-portal-control-Act-8a",
    BusinessActualPortalControlAdmin = "R-SU-portal-control-Act-8b",
    TrialBudgetPortalControlAdmin = "R-SU-portal-control-BUD-9a",
    BusinessBudgetPortalControlAdmin = "R-SU-portal-control-BUD-9b",
    ActualViewAdmin = "R-Admin-View-10",
    BudgetViewAdmin = "R-Admin-View-11",
    Admin = "R-Admin-08"
}

// A user can have multiple roles
// All emails should be lowercase for consistent comparison
export const roleEmailMap: Record < string, UserRole[] > = {
    "melmaki@kpmg.com": [UserRole.SBU],
    "kreddy21@kpmg.com": [UserRole.Admin],
};

// Define page access based on roles
export const pageAccessConfig: Record < string, UserRole[] > = {
    "/": [
        UserRole.SBU,
        UserRole.TrialActualAdmin,
        UserRole.TrialBudgetAdmin,
        UserRole.BusinessActualAdmin,
        UserRole.BusinessBudgetAdmin,
        UserRole.SBUTrialActualAdmin,
        UserRole.SBUBusinessActualAdmin,
        UserRole.SBUTrialBudgetAdmin,
        UserRole.SBUBusinessBudgetAdmin,
        UserRole.TrialActualPortalControlAdmin,
        UserRole.BusinessActualPortalControlAdmin,
        UserRole.TrialBudgetPortalControlAdmin,
        UserRole.BusinessBudgetPortalControlAdmin,
        UserRole.ActualViewAdmin,
        UserRole.BudgetViewAdmin,
        UserRole.Admin
    ],
    "/upload-files": [
        UserRole.SBU,
        UserRole.SBUTrialActualAdmin,
        UserRole.SBUBusinessActualAdmin,
        UserRole.SBUTrialBudgetAdmin,
        UserRole.SBUBusinessBudgetAdmin,
        UserRole.ActualViewAdmin,
        UserRole.BudgetViewAdmin,
        UserRole.Admin
    ],
    "/download": [
        UserRole.SBU,
        UserRole.TrialActualAdmin,
        UserRole.TrialBudgetAdmin,
        UserRole.BusinessActualAdmin,
        UserRole.BusinessBudgetAdmin,
        UserRole.ActualViewAdmin,
        UserRole.BudgetViewAdmin,
        UserRole.Admin
    ],
    "/update-files": [
        UserRole.ActualViewAdmin,
        UserRole.BudgetViewAdmin,
        UserRole.TrialActualAdmin,
        UserRole.TrialBudgetAdmin,
        UserRole.BusinessActualAdmin,
        UserRole.BusinessBudgetAdmin,
        UserRole.Admin
    ],
    "/dashboard": [
        UserRole.TrialActualAdmin,
        UserRole.TrialBudgetAdmin,
        UserRole.BusinessActualAdmin,
        UserRole.BusinessBudgetAdmin,
        UserRole.ActualViewAdmin,
        UserRole.BudgetViewAdmin,
        UserRole.Admin
    ],
    "/portal-control": [
        UserRole.TrialActualPortalControlAdmin,
        UserRole.BusinessActualPortalControlAdmin,
        UserRole.TrialBudgetPortalControlAdmin,
        UserRole.BusinessBudgetPortalControlAdmin,
        UserRole.ActualViewAdmin,
        UserRole.BudgetViewAdmin,
        UserRole.Admin
    ],
    "/help-and-support": [
        UserRole.SBU,
        UserRole.TrialActualAdmin,
        UserRole.TrialBudgetAdmin,
        UserRole.BusinessActualAdmin,
        UserRole.BusinessBudgetAdmin,
        UserRole.SBUTrialActualAdmin,
        UserRole.SBUBusinessActualAdmin,
        UserRole.SBUTrialBudgetAdmin,
        UserRole.SBUBusinessBudgetAdmin,
        UserRole.TrialActualPortalControlAdmin,
        UserRole.BusinessActualPortalControlAdmin,
        UserRole.TrialBudgetPortalControlAdmin,
        UserRole.BusinessBudgetPortalControlAdmin,
        UserRole.ActualViewAdmin,
        UserRole.BudgetViewAdmin,
        UserRole.Admin
    ]
};

export interface NavItem {
    title: string;
    navigationLink: string;
    allowedRoles: UserRole[];
}

export const navigationConfig: NavItem[] = [{
        title: "Home",
        navigationLink: "/",
        allowedRoles: Object.values(UserRole)
    },
    {
        title: "Download Templates",
        navigationLink: "/download",
        allowedRoles: [
            UserRole.SBU,
            UserRole.TrialActualAdmin,
            UserRole.TrialBudgetAdmin,
            UserRole.BusinessActualAdmin,
            UserRole.BusinessBudgetAdmin,
            UserRole.ActualViewAdmin,
            UserRole.BudgetViewAdmin,
            UserRole.Admin
        ]
    },
    {
        title: "Upload Files",
        navigationLink: "/upload-files",
        allowedRoles: [
            UserRole.SBU,
            UserRole.SBUTrialActualAdmin,
            UserRole.SBUBusinessActualAdmin,
            UserRole.SBUTrialBudgetAdmin,
            UserRole.SBUBusinessBudgetAdmin,
            UserRole.ActualViewAdmin,
            UserRole.BudgetViewAdmin,
            UserRole.Admin
        ]
    },
    {
        title: "Upload Templates",
        navigationLink: "/update-files",
        allowedRoles: [
            UserRole.ActualViewAdmin,
            UserRole.BudgetViewAdmin,
            UserRole.TrialActualAdmin,
            UserRole.TrialBudgetAdmin,
            UserRole.BusinessActualAdmin,
            UserRole.BusinessBudgetAdmin,
            UserRole.Admin
        ]
    },
    {
        title: "Dashboard",
        navigationLink: "/dashboard",
        allowedRoles: [
            UserRole.TrialActualAdmin,
            UserRole.TrialBudgetAdmin,
            UserRole.BusinessActualAdmin,
            UserRole.BusinessBudgetAdmin,
            UserRole.ActualViewAdmin,
            UserRole.BudgetViewAdmin,
            UserRole.Admin
        ]
    },
    {
        title: "Portal Control",
        navigationLink: "/portal-control",
        allowedRoles: [
            UserRole.TrialActualPortalControlAdmin,
            UserRole.BusinessActualPortalControlAdmin,
            UserRole.TrialBudgetPortalControlAdmin,
            UserRole.BusinessBudgetPortalControlAdmin,
            UserRole.ActualViewAdmin,
            UserRole.BudgetViewAdmin,
            UserRole.Admin
        ]
    },
    {
        title: "Help & Support",
        navigationLink: "/help-and-support",
        allowedRoles: Object.values(UserRole)
    }
];